import { create } from 'zustand';

// PIN brute-force lockout (too many wrong PINs). Set from a reauth 429 and shared
// across reauth prompts so the countdown persists between attempts. It gates only
// the sensitive action being reauthed (transfer, card op, seed) — never app entry
// — so ReauthFlow shows a dismissible countdown rather than blocking the app.
type LockState = {
  /** Lock-until timestamp (ms), or 0 if not locked. */
  lockedUntil: number;
  lock: (until: number) => void;
  clear: () => void;
};

export const useLockStore = create<LockState>((set) => ({
  lockedUntil: 0,
  lock: (until) => set({ lockedUntil: until }),
  clear: () => set({ lockedUntil: 0 }),
}));
